import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useAppDispatch, useAppSelector } from "../../store/hooks/store.hooks";
import "./rules.css";
import strawberry from "../../assets/ .png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CardMedia,
  Container,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import {
//   LiveChatWidget,
//   EventHandlerPayload,
//   useWidgetIsReady,
//   useWidgetState,
// } from "@livechat/widget-react";
// import { IJivoSelector } from "../../components/jivo/typing/jivo.interface";
// import { jivoSelector } from "../../components/jivo/jivo.selector";
import { userChatName } from "../../utils/chatNameFormat";
import parsePrivacyNotice from "./helpers/policy.parser";
import parseTermsRulesNotice from "./helpers/terms.parser";
import parseDefaultNotice from "./helpers/default.parser";
import { scrollTop } from "../../utils/scrollTop";

export const accordionData = [
  {
    id: 0,
    pathname: "policy",
    headerId: "policy-header",
    contentId: "policy-content",
    label: "Политика конфиденциальности",
    labelKey: "footer.navigation.policy",
    textKey: "rules.privacy.text",
  },
  {
    id: 1,
    pathname: "rules",
    headerId: "rules-header",
    contentId: "rules-content",
    label: "Правила и условия",
    labelKey: "footer.navigation.rule",
    textKey: "rules.terms.text",
  },

  {
    id: 4,
    pathname: "underage-gambling",
    headerId: "underage-gambling-header",
    contentId: "underage-gambling-content",
    label: "Политика в отношении игр несовершеннолетних",
    labelKey: "footer.navigation.underage",
    textKey: "rules.underage.text",
  },
  // {
  //   id: 3,
  //   pathname: "partners",
  //   headerId: "partners-header",
  //   contentId: "partners-content",
  //   label: "Партнерская программа",
  //   labelKey: "footer.navigation.partners",
  //   text: "4444444444444444444444444",
  // },
  {
    id: 3,
    pathname: "gambling",
    headerId: "responsive-gambling-header",
    contentId: "responsive-gambling-content",
    label: "Ответственная игра",
    labelKey: "footer.navigation.gambling",
    textKey: "rules.responsive.text",
  },
  {
    id: 2,
    pathname: "company",
    headerId: "company-header",
    contentId: "company-content",
    label: "О компании",
    labelKey: "footer.navigation.about",
    textKey: "rules.about.text",
  },
  {
    id: 5,
    pathname: "aml",
    headerId: "aml-header",
    contentId: "aml-content",
    label: "ПОЛИТИКА СОБЛЮДЕНИЯ САНКЦИЙ В ОТНОШЕНИИ АМЛ/КТФ",
    labelKey: "footer.navigation.aml",
    textKey: "rules.aml.text",
  },
];

interface IRules {}

const Rules: React.FC<IRules> = ({}) => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const [expanded, setExpanded] = React.useState<string | false>("");
  const [tabValue, setTabValue] = React.useState(1);
  const { t } = useTranslation();
  // const { loyaltyLevel, email, phone, id }: IJivoSelector =
  //   useAppSelector(jivoSelector);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // const [chatState, setChatState] = React.useState<
  //   "hidden" | "maximized" | "minimized"
  // >("minimized");

  // const widgetState = useWidgetState();
  // const isWidgetReady = useWidgetIsReady();

  // useEffect(() => {
  //   if (widgetState) {
  //     setChatState(widgetState.visibility);
  //   }
  // }, [widgetState, chatState]);

  // function handleNewEvent(event: EventHandlerPayload<"onNewEvent">) {
  //   //console.log("LiveChatWidget.onNewEvent", event);
  // }

  const currentPathname = window.location.pathname.substring(1);
  useEffect(() => {
    const matchedAccordionItem = accordionData.find(
      (item) => item.pathname === currentPathname
    );
    if (matchedAccordionItem) {
      setExpanded(matchedAccordionItem.pathname);
      setTabValue(matchedAccordionItem.id);
    }
  }, [currentPathname]);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    const matchedAccordionItem = accordionData.find(
      (item) => item.id === newValue
    );
    if (matchedAccordionItem) {
      navigate(`/${matchedAccordionItem.pathname}`);
    }
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);

      const matchedAccordionItem = accordionData.find(
        (item) => item.pathname === panel
      );
      if (matchedAccordionItem) {
        navigate(`/${matchedAccordionItem.pathname}`);
      }
    };
  useEffect(() => {
    scrollTop();
  }, []);
  return !isMobile ? (
    <>
      <Container
        className="container"
        maxWidth={false}
        disableGutters
        sx={{
          marginTop: "112px",
        }}
      >
        <Box className="rules">
          <Box>
            <Box className="rules_navigation">
              {/* {isWidgetReady && (
                <Box
                  onClick={() => {
                    setChatState("maximized");
                  }}
                  className="rules_navigation_support"
                >
                  <Box className="rules_navigation_title">Поддержка 24/7</Box>
                  <Box className="rules_navigation_subtitle">
                    Свяжитесь с нами, если у вас остались вопросы
                  </Box>
                  <CardMedia
                    className="rules_navigation_img"
                    component="img"
                    alt={"title"}
                    image={strawberry}
                  />
                </Box>
              )} */}
              <Box className="rules_navigation_menu">
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={tabValue}
                  onChange={handleChangeTab}
                  aria-label="Vertical tabs example"
                  sx={{ borderRight: 1, borderColor: "divider" }}
                  TabIndicatorProps={{
                    style: {
                      display: "none",
                    },
                  }}
                >
                  {accordionData.map((item, index) => (
                    <Tab key={index} label={t(item.labelKey)} />
                  ))}
                </Tabs>
              </Box>
            </Box>
          </Box>
          <Box className="rules__body" style={{ fontSize: "12px !important" }}>
            {accordionData.map((data, index) => (
              <TabPanel key={index} value={tabValue} index={index}>
                <Typography
                  variant={"h4"}
                  sx={{ wordBreak: "break-all", marginBottom: "30px" }}
                >
                  {t(data.labelKey)}
                </Typography>
                <Typography
                  variant={"body1"}
                  sx={{
                    wordBreak: "break-all",
                    marginBottom: "15px",
                    color: "var(--secondary-text-color)",
                  }}
                >
                  {t("rules.established")}
                </Typography>
                <Typography
                  component={"span"}
                  variant={"body2"}
                  sx={{ display: "block", height: "100%", overflowY: "auto" }}
                >
                  {data.pathname === "rules"
                    ? parseTermsRulesNotice(t(data.textKey)).map(
                        (item, index) => {
                          switch (item.type) {
                            case "heading":
                              return (
                                <h2 key={index} className="rules-item__heading">
                                  {item.text}
                                </h2>
                              ); // Хедінги без цифр як <h2>
                            case "numberedHeading":
                              return (
                                <h3
                                  key={index}
                                  className="rules-item__numbered-heading"
                                >
                                  {item.text}
                                </h3>
                              ); // Нумеровані хедінги як <h3>
                            case "subParagraph":
                              return (
                                <p
                                  key={index}
                                  className="rules-item__sub-paragraph"
                                >
                                  {item.text}
                                </p>
                              ); // Підпараграфи з відступом
                            case "paragraph":
                              return (
                                <p
                                  key={index}
                                  className="rules-item__paragraph"
                                >
                                  {item.text}
                                </p>
                              ); // Звичайні параграфи
                            case "list":
                              return (
                                <ul key={index} className="rules-item__list">
                                  {item.items.map((subitem, subIndex) => (
                                    <li
                                      key={subIndex}
                                      className="rules-item__li"
                                    >
                                      {subitem.title && (
                                        <strong>{subitem.title}</strong>
                                      )}
                                      {subitem.description && (
                                        <>
                                          {subitem.title ? ": " : ""}
                                          {Array.isArray(subitem.description)
                                            ? subitem.description.map(
                                                (part, partIndex) => (
                                                  <React.Fragment
                                                    key={partIndex}
                                                  >
                                                    {part}
                                                  </React.Fragment>
                                                )
                                              )
                                            : subitem.description}
                                        </>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              );
                            default:
                              return null;
                          }
                        }
                      )
                    : data.pathname === "policy"
                    ? parsePrivacyNotice(t(data.textKey)).map(
                        (item, item_index) => {
                          switch (item.type) {
                            case "heading":
                              return (
                                <h2
                                  key={item_index}
                                  className="rules-item__heading"
                                >
                                  {item.text}
                                </h2>
                              );
                            case "paragraph":
                              return (
                                <p
                                  key={item_index}
                                  className="rules-item__paragraph"
                                >
                                  {item.text}
                                </p>
                              );
                            case "list":
                              return (
                                <ul
                                  key={item_index}
                                  className="rules-item__list"
                                >
                                  {item.items.map((subitem, subIndex) => {
                                    return (
                                      <li
                                        key={subIndex}
                                        className="rules-item__li"
                                      >
                                        {subitem.title && (
                                          <strong>{subitem.title}</strong>
                                        )}
                                        {subitem.description && (
                                          <>
                                            {": "}
                                            {Array.isArray(subitem.description)
                                              ? subitem.description.map(
                                                  (part, partIndex) => (
                                                    <React.Fragment
                                                      key={partIndex}
                                                    >
                                                      {part}
                                                    </React.Fragment>
                                                  )
                                                )
                                              : subitem.description}
                                          </>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              );
                            default:
                              return null;
                          }
                        }
                      )
                    : parseDefaultNotice(t(data.textKey)).map(
                        (item, item_index) => {
                          switch (item.type) {
                            case "heading":
                              return (
                                <h2
                                  key={item_index}
                                  className="rules-item__heading"
                                >
                                  {item.text}
                                </h2>
                              );
                            case "paragraph":
                              return (
                                <p
                                  key={item_index}
                                  className="rules-item__paragraph"
                                >
                                  {item.text}
                                </p>
                              );
                            case "list":
                              return (
                                <ul
                                  key={item_index}
                                  className="rules-item__list"
                                >
                                  {item.items.map((subitem, subIndex) => {
                                    return (
                                      <li
                                        key={subIndex}
                                        className="rules-item__li"
                                      >
                                        <strong>{subitem.title}</strong>
                                        {subitem.description}
                                        {subitem.nestedItems && (
                                          <ul className="rules-item__nested-list">
                                            {subitem.nestedItems.map(
                                              (nested, nestedIndex) => (
                                                <li
                                                  key={nestedIndex}
                                                  className="rules-item__nested-li"
                                                >
                                                  {nested.text}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              );
                            default:
                              return null;
                          }
                        }
                      )}
                </Typography>
              </TabPanel>
            ))}
          </Box>
        </Box>
      </Container>
      {/* <LiveChatWidget
        license="18252378"
        visibility={chatState}
        customerName={`${id}: ${loyaltyLevel}` || undefined}
        customerEmail={email || undefined}
        onNewEvent={handleNewEvent}
      /> */}
      {/* <span>{widgetState?.availability}</span>
      <span>{widgetState?.visibility}</span> */}
    </>
  ) : (
    <Box
      sx={{
        marginTop: "112px",
        padding: "12px 14px",
      }}
    >
      {accordionData.map((data) => (
        <Accordion
          className="accordion"
          key={data.id}
          expanded={expanded === data.pathname}
          onChange={handleChange(data.pathname)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordion_summary"
            aria-controls={data.contentId}
            id={data.headerId}
          >
            <Typography
              sx={{
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                width: "100%",
                wordBreak: "break-all",
                overflow: "hidden",
              }}
            >
              {t(data.labelKey)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordion_details">
            <Typography
              component={"span"}
              variant={"body2"}
              sx={{ fontSize: "14px" }}
            >
              {data.pathname === "rules"
                ? parseTermsRulesNotice(t(data.textKey)).map((item, index) => {
                    switch (item.type) {
                      case "heading":
                        return (
                          <h2 key={index} className="rules-item__heading">
                            {item.text}
                          </h2>
                        ); // Хедінги без цифр як <h2>
                      case "numberedHeading":
                        return (
                          <h3
                            key={index}
                            className="rules-item__numbered-heading"
                          >
                            {item.text}
                          </h3>
                        ); // Нумеровані хедінги як <h3>
                      case "subParagraph":
                        return (
                          <p key={index} className="sub-paragraph">
                            {item.text}
                          </p>
                        ); // Підпараграфи з відступом
                      case "paragraph":
                        return (
                          <p key={index} className="rules-item__paragraph">
                            {item.text}
                          </p>
                        ); // Звичайні параграфи
                      case "list":
                        return (
                          <ul key={index} className="rules-item__list">
                            {item.items.map((subitem, subIndex) => (
                              <li key={subIndex} className="rules-item__li">
                                {subitem.title && (
                                  <strong>{subitem.title}</strong>
                                )}
                                {subitem.description && (
                                  <>
                                    {subitem.title ? ": " : ""}
                                    {Array.isArray(subitem.description)
                                      ? subitem.description.map(
                                          (part, partIndex) => (
                                            <React.Fragment key={partIndex}>
                                              {part}
                                            </React.Fragment>
                                          )
                                        )
                                      : subitem.description}
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        );
                      default:
                        return null;
                    }
                  })
                : data.pathname === "policy"
                ? parsePrivacyNotice(t(data.textKey)).map(
                    (item, item_index) => {
                      switch (item.type) {
                        case "heading":
                          return (
                            <h2
                              key={item_index}
                              className="rules-item__heading"
                            >
                              {item.text}
                            </h2>
                          );
                        case "paragraph":
                          return (
                            <p
                              key={item_index}
                              className="rules-item__paragraph"
                            >
                              {item.text}
                            </p>
                          );
                        case "list":
                          return (
                            <ul key={item_index} className="rules-item__list">
                              {item.items.map((subitem, subIndex) => {
                                return (
                                  <li key={subIndex} className="rules-item__li">
                                    {subitem.title && (
                                      <strong>{subitem.title}</strong>
                                    )}
                                    {subitem.description && (
                                      <>
                                        {": "}
                                        {Array.isArray(subitem.description)
                                          ? subitem.description.map(
                                              (part, partIndex) => (
                                                <React.Fragment key={partIndex}>
                                                  {part}
                                                </React.Fragment>
                                              )
                                            )
                                          : subitem.description}
                                      </>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          );
                        default:
                          return null;
                      }
                    }
                  )
                : parseDefaultNotice(t(data.textKey)).map(
                    (item, item_index) => {
                      switch (item.type) {
                        case "heading":
                          return (
                            <h2
                              key={item_index}
                              className="rules-item__heading"
                            >
                              {item.text}
                            </h2>
                          );
                        case "paragraph":
                          return (
                            <p
                              key={item_index}
                              className="rules-item__paragraph"
                            >
                              {item.text}
                            </p>
                          );
                        case "list":
                          return (
                            <ul key={item_index} className="rules-item__list">
                              {item.items.map((subitem, subIndex) => {
                                return (
                                  <li key={subIndex} className="rules-item__li">
                                    {subitem.title && (
                                      <strong>{subitem.title}</strong>
                                    )}
                                    {subitem.description && (
                                      <>
                                        {": "}
                                        {Array.isArray(subitem.description)
                                          ? subitem.description.map(
                                              (part, partIndex) => (
                                                <React.Fragment key={partIndex}>
                                                  {part}
                                                </React.Fragment>
                                              )
                                            )
                                          : subitem.description}
                                      </>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          );
                        default:
                          return null;
                      }
                    }
                  )}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      {/* <LiveChatWidget
        license="18252378"
        visibility={chatState}
        customerName={userChatName(id, loyaltyLevel)}
        customerEmail={email || undefined}
        onNewEvent={handleNewEvent}
      /> */}
      {/* <span>{widgetState?.availability}</span>
      <span>{widgetState?.visibility}</span> */}
    </Box>
  );
};

export default Rules;
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
